import React from 'react';
import PropTypes from 'prop-types';
import { ExtraBalanceVerifiedWrapperStyled as ExtraBalanceVerifiedWrapper } from './styles/ExtraBalanceVerifiedStyled';
import BundleDetails from './BundleDetails/BundleDetails';

const ExtraBalanceVerified = ({ categories, setOffer, closePanel }) => {
  return (
    <ExtraBalanceVerifiedWrapper>
      <BundleDetails
        categories={categories}
        setOffer={setOffer}
        closePanel={closePanel}
      />
    </ExtraBalanceVerifiedWrapper>
  );
};

ExtraBalanceVerified.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setOffer: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

export default ExtraBalanceVerified;
